<script>
  import { getNotificationsContext } from "svelte-notifications";
  import StepBase from "./StepBase.svelte";
  import SettingIconButton from "../../../components/IconButtons/SettingIconButton.svelte";
  import EditItemParametersDialog from "./parametersStep/parts/EditItemParametersDialog.svelte";
  import SelectParametersDialog from "./parametersStep/parts/SelectParametersDialog.svelte";
  import PropertiesDataTable from "../../parts/PropertiesDataTable.svelte";
  import { constructParameterDataPropertiesHeaders } from "../../parts/PropertiesDataTableUtils.js";
  import { getAutoMpsProjectContext } from "../../AutoMpsProjectContext.js";
  import Loading from "../../../components/pages/Loading.svelte";
  import { localizeImportedAt } from "./importStep/parts/tableUtils.js";

  export let selectedParameterDataId

  export let onClickNext

  export let onClickBack

  const ctx = getAutoMpsProjectContext()
  const {addNotification} = getNotificationsContext()

  /**
   * @type {"loading"|"loaded"|"error"}
   */
  let status = "loading"

  let metadata = null
  let parameterData = null
  async function getParameterData(id) {
    const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/imports/parameter/${id}`)

    if (!response.ok) {
      status = "error"
      return addNotification({
        type: "error",
        removeAfter: 4000,
        text: `データの取得に失敗しました。`,
        position: "top-right",
      })
    }

    const data = await response.json()
    parameterData = data.data
    metadata = data.meta
    status = "loaded"
  }
  $: getParameterData(selectedParameterDataId)

  const headers = constructParameterDataPropertiesHeaders([
    {
      name: "編集する",
      key: "__edit",
      onClick: (row) => {
        currentlyEditedItemCode = row.itemCode
      }
    }
  ])

  let currentlyEditedItemCode = null
  let hasBeenEdited = false
  function applyItemParametersEdit(editedItemParameters) {
    const index = parameterData.findIndex(item => item.itemCode === editedItemParameters.itemCode)
    if (index === -1) return
    hasBeenEdited = true
    parameterData[index] = editedItemParameters
  }

  let isSelectParametersDialogOpen = false

  async function handleClickNext() {
    // save the edited data
    if (hasBeenEdited) {
      const payload = {
        meta: {
          importMethod: "manual",
        },
        data: parameterData,
      }
      const response = await fetch(`/api/auto-mps/projects/${$ctx.projectId}/imports/parameter`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      })
      if (!response.ok) {
        return addNotification({
          type: "error",
          removeAfter: 4000,
          text: `データの保存に失敗しました。`,
          position: "top-right",
        })
      }
      selectedParameterDataId = (await response.json()).meta.id
    }
    onClickNext()
  }
</script>

<StepBase onClickNext={handleClickNext} onClickBack={onClickBack}>
  <div style="margin: 1rem">
    平準化計画を立てるときに使用するパラメタを確認しましょう。
  </div>
  <hr />
  {#if status === "loading"}
    <Loading height="50vh" />
  {/if}
  {#if status === "error"}
    <div>読み込みに失敗しました。</div>
  {/if}
  {#if status === "loaded"}
    <div style="margin: 1rem; display: inline-flex; justify-content: space-between; align-items: center; gap: 1rem">
      <div>
        現在選択されている平準化パラメタ:
        <span>
           ({localizeImportedAt(metadata.importedAt, "ja")} インポート)
        </span>
      </div>
      <SettingIconButton onClick={() => isSelectParametersDialogOpen = true} />
    </div>
    <PropertiesDataTable
      headers={headers}
      rows={parameterData}
    />
  {/if}
</StepBase>
{#if currentlyEditedItemCode && parameterData}
  <EditItemParametersDialog
    onClose={() => currentlyEditedItemCode = null}
    onSave={(edited) => {currentlyEditedItemCode = null; applyItemParametersEdit(edited)}}
    itemParameters={parameterData.find(item => item.itemCode === currentlyEditedItemCode)}
  />
{/if}
{#if isSelectParametersDialogOpen}
  <SelectParametersDialog onClose={() => isSelectParametersDialogOpen = false} />
{/if}

<style>
  hr {
    color: lightgrey;
  }
</style>
